import { render, staticRenderFns } from "./modalCadastro.vue?vue&type=template&id=6e1dfacc"
import script from "./modalCadastro.vue?vue&type=script&lang=js"
export * from "./modalCadastro.vue?vue&type=script&lang=js"
import style0 from "./modalCadastro.vue?vue&type=style&index=0&id=6e1dfacc&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports